import BaseUISystem from '../BaseUISystem';
import BaseMenu from './BaseMenu';
import { GameObjectEvent } from 'GameObject/GameObject';
import { UIActions } from 'State/UI/UIActions';
import { applyDefaultButtonAnimation } from '../UIHelper';
import { PopupID } from 'State/UI/PopupID';
import RelativePositionComponent from 'Component/Render/RelativePosition';
import Point from 'Utility/Point';
import { ChristmasFTUXLayout } from 'Layouts/ChristmasFTUXLayout';
import Game from "Game";

export default class EventIntroHandler extends BaseMenu {
    private layout: any;

    constructor(uiSystem: BaseUISystem) {
        super(PopupID.EVENT_INTRO, uiSystem, false);

        if (!Game.resource.existsOrQueued('xmas_2021')) {
            this.resources.set('xmas_2021', 'resource/graphics/sprite_sheets/xmas_2021.json');
        }
    }

    public async preload(): Promise<void> {
        return super.preload();
    }

    public onCreate() {
        super.onCreate();

        // Create layout.
        this.layout = new ChristmasFTUXLayout();
        this.layout.root.addComponent(RelativePositionComponent);
        this.layout.root.getComponent(RelativePositionComponent).relativePosition = new Point(0.5, 0.5);
        this.element.addChild(this.layout.root);

        // Prepare buttons.
        const { closeButton, startButton } = this.layout;

        // Both buttons close the popup.
        [closeButton, startButton].forEach(button => {
            applyDefaultButtonAnimation(button);
            button.once(GameObjectEvent.SELECTED, () => {
                UIActions.hidePopup(PopupID.EVENT_INTRO);
            });
        });
    }
}
